import "./index.css"
import React from "react"
import "./i18n"
import ReactDOM from "react-dom/client"
import { Provider } from "react-redux"
import { store } from "./redux/store"
import { RouterProvider } from "react-router-dom"
import { router } from "./routes/routes"
import { createTheme, ThemeProvider } from "@mui/material"
import { I18nextProvider } from "react-i18next"
import i18n from "./i18n"
import "moment/dist/locale/he"
import { SnackbarProvider } from "notistack"

const root = ReactDOM.createRoot(document.getElementById("root")!)

export const theme = createTheme({
  direction: "ltr",
  typography: {
    fontFamily: "inherit", // This will respect the language-based font selection
  },
})

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <I18nextProvider i18n={i18n}>
        <SnackbarProvider autoHideDuration={3000}>
          <RouterProvider router={router} />
          </SnackbarProvider>
        </I18nextProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
)
